<template>
  <div
    :class="`mdn-Modal mdn-Modal--${sizeModal} mdn-isOpen dialog-container`"
    v-if="showModal"
    @click.self="$emit('isClose', true)"
  >
    <div class="mdn-Modal-content" tabindex="0" ref="dialog">
      <div class="modal-header" v-if="showHeader">
        <div
          class="mdn-Heading mdn-Heading--md"
          :class="titleDescriptionClass"
          v-html="title"
        />
        <button
          class="mdn-Button-header-close mdn-Button border-icon mdn-Button--secondary"
          aria-label="Close modal"
          v-show="showButtonClose"
          :title="closeTitle"
          @click.prevent="$emit('isClose', true)"
        >
          <i class="mdn-Icon-fechar mdn-Icon--sm"></i>
        </button>
      </div>
      <div class="mdn-Divider mdn-Divider--default" v-if="showHeader"></div>
      <div
        class="mdn-Modal-body"
        :style="isDialogType === 'webview' ? { overflow: 'hidden' } : ''"
      >
        <div v-if="isDialogType === 'webview'">
          <iframe
            :style="
              detectMob
                ? { width: '325px', height: '450px' }
                : { width: '710px', height: '400px' }
            "
            :src="uriFrame.concat('?t=').concat(token)"
            frameborder="0"
          ></iframe>
        </div>
        <div v-if="isQrCodeAlert">
          <v-icon style="margin-left: 340px">{{ "close" }}</v-icon>
        </div>
        <div
          class="mdn-Text mdn-Text--body container-modal"
          :class="textDescriptionClass"
          v-html="description"
          v-if="description.length > 0"
        />
        <slot />
      </div>
      <div class="mdn-Modal-footer container-footer-modal" v-if="showFooter">
        <div
          :class="`mdn-Modal-footer-end`"
          v-if="isDialogType === 'confirmation'"
        >
          <button
            class="mdn-Button mdn-Button--secondary"
            @click.prevent="$emit('isClose', true)"
          >
            Cancelar
          </button>
          <button
            class="mdn-Button mdn-Button--primary"
            @click.prevent="$emit('buttonConfirmation', true)"
          >
            Confirmar
          </button>
        </div>
        <div :class="`mdn-Modal-footer-end`" v-if="isDialogType === 'warning'">
          <button
            class="mdn-Button mdn-Button--primary"
            :title="okTitle"
            @click.prevent="$emit('buttonConfirmation', true)"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "Dialog",
})
export default class Dialog extends Vue {
  @Prop({ default: true }) showModal!: boolean;

  @Prop({ default: "" }) title!: string;

  @Prop({ default: "" }) description!: string;

  @Prop({ default: "" }) textDescriptionClass!: string;

  @Prop({ default: "" }) titleDescriptionClass!: string;

  @Prop({ default: "Entendi" }) buttonText?: string;

  @Prop({ default: true }) showButtonClose?: boolean;

  @Prop({ default: true }) showHeader?: boolean;

  @Prop({ default: true }) showFooter?: boolean;

  @Prop({ default: "confirmation" }) isDialogType?: string;

  @Prop({ default: false }) readonly isQrCodeAlert!: boolean;

  @Prop({ default: false }) readonly isPaynentAlert?: boolean;

  @Prop({ default: "sm" }) sizeModal?: "sm" | "lg";

  @Prop({ default: "" }) token?: string;

  @Prop({ default: false }) readonly detectMob?: boolean;

  @Prop({ default: "" }) readonly closeTitle?: string;

  @Prop({ default: "" }) readonly okTitle?: string;

  uriFrame = process.env.VUE_APP_API_M4U_FRAME;
}
</script>

<style lang="scss">
.modal-header {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.5rem;

  .border-icon {
    min-width: 0;
    width: 2rem;
    height: 2rem;
    padding: 0;
    border-radius: var(--theme-border-radius-circle);
  }
}
.dialog-container {
  @media screen and (min-width: 64rem) {
    .mdn-Modal-content {
      height: auto;
    }
  }
}

.container-modal {
  display: block;
  position: relative;
  min-height: 130px;
  max-height: 200px;
  overflow-y: auto;
}

.container-footer-modal {
  margin-top: 0 !important;
  padding-top: 5px !important;
}

.text-center-force {
  width: 100%;
  text-align: center !important;
}
</style>
